import { render, staticRenderFns } from "./indexbak.vue?vue&type=template&id=210ab700&scoped=true"
import script from "./indexbak.vue?vue&type=script&lang=js"
export * from "./indexbak.vue?vue&type=script&lang=js"
import style0 from "./indexbak.vue?vue&type=style&index=0&id=210ab700&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ab700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\certbuyliantuo\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('210ab700')) {
      api.createRecord('210ab700', component.options)
    } else {
      api.reload('210ab700', component.options)
    }
    module.hot.accept("./indexbak.vue?vue&type=template&id=210ab700&scoped=true", function () {
      api.rerender('210ab700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/indexbak.vue"
export default component.exports